import styles from "./CustomInput.module.css";

const CustomInput = ({
  labelText,
  placeholder,
  type,
  name,
  onBlur,
  onChange,
  value,
}) => {
  return (
    <label className={styles.inputLabel}>
      {labelText && <p className={styles.inputLabelText}>{labelText}</p>}
      <input
        onBlur={onBlur}
        onChange={onChange}
        name={name}
        value={value}
        type={type}
        placeholder={placeholder}
        className={styles.input}
      />
    </label>
  );
};
export default CustomInput;
